module.exports = __webpack_public_path__ + "html/salma-webinars_9928f481310ddc1558c335ae54f402e3.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/salma-webinars.html
// module id = EStm
// module chunks = 35